import { get } from "svelte/store";
import { isNetworkGame } from "./net";
import { prefs } from "./stores";
import { Howl } from "howler";

let soundURLs = {
    joined: 'https://trekcore.com/audio/aliensounds/alien_materialization_tos.mp3',
    handover: 'https://www.trekcore.com/audio/tricorder/tos_tricoder_alert.mp3',//'tos_tricoder_alert.mp3',
    effect_offer: 'https://www.trekcore.com/audio/computer/communications_start_transmission.mp3',//'communications_start_transmission.mp3',
    effect_response: 'https://www.trekcore.com/audio/computer/communications_end_transmission.mp3', //'communications_end_transmission.mp4',
    burn_warning: 'https://www.trekcore.com/audio/computer/voice/warninglastchancetobeaherodoctor_ep.mp3',//'warninglastchancetobeaherodoctor_ep.mp3'
    self_destruct: 'https://trekcore.com/audio/computer/voice/selfdestructsequenceinitiatedwarpcorebreach_ep.mp3'
}

let sounds = {};

for(let k of Object.keys(soundURLs)){
    sounds[k] = {
        url: soundURLs[k],
        howl: false
    }
}


export function setupSounds(){
    for(let k of Object.keys(sounds)){
        let sound = new Howl({
            src: sounds[k].url
        });
        sounds[k].howl = sound;
    }
}

export function playSound(sound, forced = false){
    if(!get(prefs).playSounds) return;
    if(get(prefs).playSounds == 'network' && !isNetworkGame() && !forced) return false;
    if(!sounds[sound] || !sounds[sound].howl){
        console.log('Help: unable to find sound!', sound, sounds);
        return;
    }
    sounds[sound].howl.play();
}